<!--
 * @Description: 流程审批代理详情
 * @Autor: lwq
 * @Date: 2020-07-29 09:32:35
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:24:16
 * @FilePath: \mrc-base-frontend\src\views\approvertype\detail.vue
--> 
<template>
  <div>
    <!--    :showEdit="hasBtn('edit-approval-business-type')"
                       :show_del="hasBtn('delete-approval-business-type')" -->
    <mrc_ess_iconGroup
      :is_disabled="disabled"
      :showReturn="false"
      :showEdit="hasBtn('edit-approval-business-type')"
      :show_del="hasBtn('delete-approval-business-type')"
      @handleReturn="handleReturn"
      @handleEdit="handleEdit"
      @handleDel="handleDel"
    ></mrc_ess_iconGroup>
    <approverInfo :disabled="disabled" @changeReadonly="handleEdit" />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import approverInfo from "./modules/approverInfo";
import { updateApprover, delApprovertype } from "@/service/api/approvertype";
export default {
  components: { approverInfo },
  props: {},
  data() {
    return {
      disabled: false,
    };
  },
  validations: {},
  computed: {},
  created() {},
  watch: {},
  async mounted() {
    this.disabled = this.$store.state.iconstatus;
  },
  methods: {
    handleReturn() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.disabled = !this.disabled;
      this.$store.commit("set_iconstatus", this.disabled);
    },
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then((res) => {
        delApprovertype({ uuid: this.$store.state.uuid }).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            this.$router.push({
              name: "approvertype",
              params: {
                type: "del",
              },
            });
          }
        });
      });
    },
  },
};
</script>

<style scoped>
</style>
